import script from "./PreviewBody.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewBody.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewBody.vue?vue&type=style&index=0&id=60dea494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60dea494"]])

export default __exports__